module.exports = __webpack_public_path__ + "static/media/Striped Horse QHSE Policy.641b9cfd.pdf";